(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/intersectionBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/intersectionBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.intersectionBy, global.convert);
    global.intersectionBy = mod.exports;
  }
})(this, function (exports, _intersectionBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.intersectionBy = undefined;

  var _intersectionBy3 = _interopRequireDefault(_intersectionBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.intersection} except that it uses <code>iteratee</code> to generate the value to be compared for each element.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} [arrays] The arrays to inspect.
   * @param {Function} [iteratee={@link https://lodash.com/docs#identity|lodash.identity}] The iteratee invoked per element.
   * @return {Object} Returns the updated object.
   * @example intersectionBy({ nested: { prop: [1.2, 2.1] } }, 'nested.prop', [2.3, 3.2], Math.floor) // => { nested: { prop: [2.1] } }
   * @see {@link https://lodash.com/docs#intersectionBy|lodash.intersectionBy} for more information.
   * @since 0.3.0
   */
  var intersectionBy = (0, _convert.convert)(_intersectionBy3.default);
  exports.intersectionBy = intersectionBy;
  exports.default = intersectionBy;
});